(function (angular) {
	'use strict';

	angular
		.module('coreModule')
		.factory('ModalFactory', [
			'$animate',
			'$document',
			'$compile',
			'$controller',
			'$filter',
			'$http',
			'$q',
			'$rootScope',
			'$templateRequest',
			'$timeout',
			'DISCLAIMER_MAP',
			'STATIC_BASE_PATH',
			ModalFactoryFunction
		]);

	function ModalFactoryFunction(
		$animate,
		$document,
		$compile,
		$controller,
		$filter,
		$http,
		$q,
		$rootScope,
		$templateRequest,
		$timeout,
		DISCLAIMER_MAP,
		STATIC_BASE_PATH) {

		var factory = {
			openStandard: openStandard,
			openDisclaimer: openDisclaimer,
			openMediaGallery: openMediaGallery,
			openOpportunityFundSignup: openOpportunityFundSignup,
			showModal: showModal,
			openReitElement: openReitElement,
			openCancelTransaction: openCancelTransaction,
			openCancelRedemptionRequestTransaction: openCancelRedemptionRequestTransaction,
			openChangeBankAccount: openChangeBankAccount,
			openLeavingFundrise: openLeavingFundrise,
			openRemoveDevice: openRemoveDevice,
			openModals: []
		};

		return factory;

		function openStandard(props) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/standard-modal.html',
				controller: 'StandardModalController',
				controllerAs: 'standardModal',
				inputs: props
			};

			showModal(options);
		}

		function openDisclaimer(disclaimerName, props) {
			var contentTemplateUrl = STATIC_BASE_PATH + DISCLAIMER_MAP[disclaimerName];

			getTemplate(undefined, contentTemplateUrl)
				.then(function(template) {
					props.inputs.content = template;

					var options = {
						templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/standard-modal.html',
						controller: 'StandardModalController',
						controllerAs: 'standardModal',
						inputs: props
					};

					showModal(options);
				});
		}

		function openMediaGallery(props) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/media-modal.html',
				controller: 'MediaGalleryModalController',
				controllerAs: 'mediaGalleryModal',
				inputs: props
			};

			showModal(options);
		}

		function openOpportunityFundSignup() {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/opportunity-fund-signup-modal.html',
				controller: 'OpportunityFundSignupModalController',
				controllerAs: 'opportunityFundSignupModal'
			};

			return showModal(options);
		}

		function openReitElement(props) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-modal.html',
				controller: 'ReitElementModalController',
				controllerAs: 'reitElementModal',
				inputs: props
			};

			showModal(options);
		}

		function openCancelTransaction(cancelTransactionData) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/investor-dashboard/cancel-transaction-modal/cancel-transaction-modal.html',
				controller: 'CancelTransactionModalController',
				controllerAs: 'cancelTransactionModal',
				inputs: cancelTransactionData
			};

			showModal(options);
		}

		function openCancelRedemptionRequestTransaction(cancelRedemptionRequestData) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/investor-dashboard/cancel-redemption-request-modal/cancel-redemption-request-modal.html',
				controller: 'CancelRedemptionRequestModalController',
				controllerAs: 'cancelRedemptionRequestModal',
				inputs: cancelRedemptionRequestData
			};

			showModal(options);
		}

		function openChangeBankAccount(changeBankAccountData) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/investor-dashboard/change-bank-account-modal/change-bank-account-modal.html',
				controller: 'ChangeBankAccountModalController',
				controllerAs: 'changeBankAccountModal',
				inputs: {
					changeBankAccountDto: changeBankAccountData
				}
			};

			showModal(options);
		}

		function openLeavingFundrise(leavingFundriseData) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/leaving-fundrise-modal.html',
				controller: 'LeavingFundriseModalController',
				controllerAs: 'leavingFundriseModal',
				inputs: leavingFundriseData
			};

			return showModal(options);
		}

		function openRemoveDevice(device) {
			var options = {
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/remove-device-modal.html',
				controller: 'RemoveDeviceModalController',
				controllerAs: 'removeDevice',
				inputs: {
					device: device
				}
			};

			return showModal(options);
		}

		function measureScrollbarWidth() {
			var measuringDiv = document.createElement('div');
			measuringDiv.style.width = '100px';
			measuringDiv.style.height = '100px';
			measuringDiv.style.overflow = 'scroll';
			measuringDiv.style.position = 'absolute';
			measuringDiv.style.top = '-9999px';
			document.body.appendChild(measuringDiv);
			var scrollbarWidth = measuringDiv.offsetWidth - measuringDiv.clientWidth;
			document.body.removeChild(measuringDiv);
			return scrollbarWidth;
		}

		function showModal(options) {

			//  Get the body of the document, we'll add the modal to this.
			var body = angular.element($document[0].body);

			//  Create a deferred we'll resolve when the modal is ready.
			var deferred = $q.defer();

			//  Validate the input parameters.
			var controllerName = options.controller;
			if (!controllerName) {
				deferred.reject("No controller has been specified.");
				return deferred.promise;
			}

			// Create the backdrop and add it to the page
			var backdrop = angular.element('<div class="modal-backdrop fade"></div>');
			body.append(backdrop);

			// Add the class to start the animation
			$timeout(function() {
				backdrop.addClass('in');
			}, 1);

			//  Get the actual html of the template.
			getTemplate(options.template, options.templateUrl)
				.then(function(template) {

					//  The main modal object we will build.
					var modal = {};

					//  Create a new scope for the modal.
					var modalScope = (options.scope || $rootScope).$new(),
							rootScopeOnClose = null,
							locationChangeSuccess = options.locationChangeSuccess;

						//  Allow locationChangeSuccess event registration to be configurable.
						//  True (default) = event registered immediately
						//  # (greater than 0) = event registered with delay
						//  False = disabled
						if (locationChangeSuccess === false){
								rootScopeOnClose = angular.noop;
						}
						else if (angular.isNumber(locationChangeSuccess) && locationChangeSuccess >= 0) {
								$timeout(function() {
										rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);
								}, locationChangeSuccess);
						}
						else {
								rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);
						}

					//  Create the inputs object to the controller - this will include
					//  the scope, as well as all inputs provided.
					//  We will also create a deferred that is resolved with a provided
					//  close function. The controller can then call 'close(result)'.
					//  The controller can also provide a delay for closing - this is
					//  helpful if there are closing animations which must finish first.
					var closeDeferred = $q.defer();
					var closedDeferred = $q.defer();
					var closing = false;
					var inputs = {
						$scope: modalScope,
						close: function(result, delay) {

							// Remove the animation classes immediately
							angular.element(modal.element[0]).removeClass('in');
							angular.element(modal.backdrop[0]).removeClass('in');
							if(!closing) {
								$timeout(function() {
									cleanUpClose(result);
								}, 500);
							}

							closing = true;
						},
						ignoreClose: function($event) {
							if ($event.stopPropagation) {
								$event.stopPropagation();
							}
						}
					};

					//  If we have provided any inputs, pass them to the controller.
					if (options.inputs) {
						angular.extend(inputs, options.inputs);
					}

					//  Compile then link the template element, building the actual element.
					//  Set the $element on the inputs so that it can be injected if required.
					var linkFn = $compile(template);
					var modalElement = linkFn(modalScope);
					inputs.$element = modalElement;

					//  Create the controller, explicitly specifying the scope to use.
					var controllerObjBefore = modalScope[options.controllerAs];
					var modalController = $controller(options.controller, inputs, false, options.controllerAs);

					if (options.controllerAs && controllerObjBefore) {
						angular.extend(modalController, controllerObjBefore);
					}

					//  Then, append the modal to the dom.
					if (options.appendElement) {
						// append to custom append element
						appendChild(options.appendElement, modalElement);
					} else {
						// append to body when no custom append element is specified
						appendChild(body, modalElement);
					}

					// Add the class to start the animation
					$timeout(function() {
						modalElement.addClass('in');
					}, 1);

					// Append class to the body to kill the scrollbar
					body[0].classList.add('modal-open');

					// Add padding since we removed the scrollbar to keep content from shifting
					var scrollbarWidth = measureScrollbarWidth() + 'px';
					var mainNav = document.getElementById('main-nav');
					if(mainNav === null) {
						mainNav = {
							style: {
								paddingRight: undefined
							}
						};
					}

					body[0].style.paddingRight = scrollbarWidth;
					mainNav.style.paddingRight = scrollbarWidth;

					//  Populate the modal object...
					modal.controller = modalController;
					modal.scope = modalScope;
					modal.element = modalElement;
					modal.backdrop = backdrop;
					modal.close = closeDeferred.promise;
					modal.closed = closedDeferred.promise;
					//  ...which is passed to the caller via the promise.
					deferred.resolve(modal);

					// Clear previous input focus to avoid open multiple modals on enter
					document.activeElement.blur();

					//  We can track this modal in our open modals.
					factory.openModals.push({ modal: modal, close: inputs.close });

					function cleanUpClose(result) {

						//  Resolve the 'close' promise.
						closeDeferred.resolve(result);

						//  Remove the custom class from the body
						body[0].classList.remove('modal-open');

						// Remove the scrollbar padding from the body and main nav
						body[0].style.paddingRight = null;
						mainNav.style.paddingRight = null;

						backdrop.remove();

						//  Let angular remove the element and wait for animations to finish.
						$animate.leave(modalElement)
							.then(function () {
								//  Resolve the 'closed' promise.
								closedDeferred.resolve(result);

								//  We can now clean up the scope
								if(modalScope) {
									modalScope.$destroy();
								}

								//  Remove the modal from the set of open modals.
								for (var i=0; i<factory.openModals.length; i++) {
									if (factory.openModals[i].modal === modal) {
										factory.openModals.splice(i, 1);
										break;
									}
								}

								//  Unless we null out all of these objects we seem to suffer
								//  from memory leaks, if anyone can explain why then I'd
								//  be very interested to know.
								deferred = null;
								closeDeferred = null;
								modal = null;
								inputs = null;
								modalElement = null;
								modalScope = null;
							});

						// remove event watcher
						rootScopeOnClose();
					}

				})
				.then(null, function(error) { // 'catch' doesn't work in IE8.
					deferred.reject(error);
				});

			return deferred.promise;
		}

		//  Adds an element to the DOM as the last child of its container
		//  like append, but uses $animate to handle animations. Returns a
		//  promise that is resolved once all animation is complete.
		function appendChild (parent, child) {
			var children = parent.children();
			if (children.length > 0) {
				return $animate.enter(child, parent, children[children.length - 1]);
			}
			return $animate.enter(child, parent);
		}

		function getTemplate (template, templateUrl) {
			var deferred = $q.defer();
			if (template) {
				deferred.resolve(template);
			} else if (templateUrl) {
				$templateRequest(templateUrl, true)
					.then(function(template) {
						deferred.resolve(template);
					}, function(error) {
						deferred.reject(error);
					});
			} else {
				deferred.reject("No template or templateUrl has been specified.");
			}
			return deferred.promise;
		}

	}
})(window.angular);
